class AccordionAnimation {
  private accordions: HTMLDetailsElement[];
  private readonly animationDuration = 300; // ミリ秒
  private animatingElements: Set<HTMLDetailsElement> = new Set();

  constructor() {
    this.accordions = Array.from(
      document.querySelectorAll('.p-planAccDetails')
    );
    this.initializeAccordions();
  }

  private initializeAccordions(): void {
    this.accordions.forEach((accordion) => {
      const content = accordion.querySelector('.p-planAccImage') as HTMLElement;

      // 初期状態ではコンテンツの高さを0に設定
      if (!accordion.open) {
        content.style.height = '0';
        content.style.overflow = 'hidden';
      }

      accordion.addEventListener('click', (e: Event) => {
        // summaryをクリックした時のみ処理を実行
        if ((e.target as HTMLElement).closest('summary')) {
          e.preventDefault();
          this.toggleAccordion(accordion);
        }
      });
    });
  }

  private async toggleAccordion(accordion: HTMLDetailsElement): Promise<void> {
    // アニメーション中なら処理を中断
    if (this.animatingElements.has(accordion)) return;

    const content = accordion.querySelector('.p-planAccImage') as HTMLElement;
    const isOpen = accordion.open;

    // アニメーション中フラグを設定
    this.animatingElements.add(accordion);

    if (!isOpen) {
      // 閉じている状態から開く
      accordion.open = true;
      const height = content.scrollHeight;
      content.style.height = '0';
      content.style.overflow = 'hidden';

      // 次のフレームで高さをアニメーション
      requestAnimationFrame(() => {
        content.style.transition = `height ${this.animationDuration}ms ease-in-out`;
        content.style.height = `${height}px`;
      });

      // アニメーション完了後
      await this.waitForTransition(content);
      content.style.height = 'auto';
      content.style.overflow = 'visible';
    } else {
      // 開いている状態から閉じる
      const height = content.scrollHeight;
      content.style.height = `${height}px`;
      content.style.overflow = 'hidden';

      // 次のフレームで高さをアニメーション
      requestAnimationFrame(() => {
        content.style.transition = `height ${this.animationDuration}ms ease-in-out`;
        content.style.height = '0';
      });

      // アニメーション完了後
      await this.waitForTransition(content);
      accordion.open = false;
    }

    // アニメーション完了フラグを解除
    content.style.transition = '';
    this.animatingElements.delete(accordion);
  }

  private waitForTransition(element: HTMLElement): Promise<void> {
    return new Promise((resolve) => {
      element.addEventListener('transitionend', () => resolve(), {
        once: true,
      });
    });
  }
}

// DOMの読み込み完了後にインスタンスを作成
document.addEventListener('DOMContentLoaded', () => {
  new AccordionAnimation();
});
